import { PlanningBoardView } from '../_types/base-planning-board-view.type';

export const DEFAULT_PLANNING_BOARD_VIEW: PlanningBoardView = 'weekly';
